import "./AppModuleUI.css"
import React, {CSSProperties, ReactElement, useState} from "react"
import {AppModule} from "./AppModule";
import {useDispatch} from "react-redux";
import {useHistory} from "react-router-dom";
import * as CoreActions from "../../../../core/store/core-actions";

const AppModuleUI = (module: AppModule): ReactElement => {
    const [hover, setHover] = useState(false);
    const history = useHistory();
    const dispatch = useDispatch();

    const moduleStyle: CSSProperties = {
        backgroundColor: module.enabled
            ? hover
                ? "var(--gray-very-pale-color)" // slightly darker when hovered
                : "white"
            : "var(--gray-very-pale-color)",
        cursor: module.enabled ? "pointer" : "not-allowed",
        width: "490px",
        height: "140px",
        borderRadius: "10px",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        display: "grid",
        gridTemplateColumns: "100px 1fr",
    };

    const titleStyle: CSSProperties = {
        color: module.enabled ? "var(--blue-dark-color)" : "var(--gray-light-color)"
    }

    const subtitleStyle: CSSProperties = {
        color: module.enabled ? "var(--gray-dark-color)" : "var(--gray-light-color)"
    }

    const iconStyle: CSSProperties = {
        opacity: module.enabled ? "1.0" : "0.5"
    }

    const handleClick = () => {
        if (!module.enabled) return;

        dispatch(CoreActions.setCurrentPageName(module.route)); // optional
        history.push(module.route);
    };

    return (
        <div
            className="module"
            style={moduleStyle}
            onClick={handleClick}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            role="button"
            tabIndex={0}
            aria-disabled={!module.enabled}
        >
            <div className="module-left">
                <div className="module-icon" style={iconStyle}>
                    {module.icon}
                </div>
            </div>
            <div className="module-right">
                <div className="module-title" style={titleStyle}>
                    {module.title}
                </div>
                <div className="module-subtitle" style={subtitleStyle}>
                    {module.subtitle}
                </div>
            </div>
        </div>
    );
}

export default AppModuleUI;
